import styled, { css } from 'styled-components';
import { pxToRem } from '../../../design-tokens/style-utilities';
const bottomSheetHeaderContainerStyles = ({ theme }) => css `
	background-color: ${theme.colors.blanc.bgModal};
	padding: ${pxToRem(theme.spacing['200'])} ${pxToRem(theme.spacing['300'])} 0;
	border-bottom: ${pxToRem(theme.borderWidth['1'])} solid ${theme.colors.light.divider};
	border-radius: ${pxToRem(theme.borderRadius.m)} ${pxToRem(theme.borderRadius.m)} 0 0;
	display: flex;
	justify-content: space-between;
	align-items: baseline;

	> * {
		display: inline-block;
	}
`;
export const BottomSheetHeaderContainer = styled.div `
	${bottomSheetHeaderContainerStyles}
`;
